<template>
  <!-- 仅 ADMIN / ASSISTANT 可见; 其他角色返回空节点 -->
  <el-tag
    v-if="canSeeSource && source"
    :type="tagType"
    size="mini"
    effect="plain"
    :class="['source-badge', `source-${(source || '').toLowerCase()}`]">
    <i :class="iconClass" />
    {{ label }}
  </el-tag>
</template>

<script>
/**
 * 项目/会议/结算单 来源标识徽章
 *
 * 可见性: 仅 ADMIN / ASSISTANT 渲染. 其他角色看到的就是空, 跟没加这个组件一样.
 * 来源: MANUAL=自建(蓝) / XJD=社组(橙)
 */
export default {
  name: 'SourceBadge',
  props: {
    source: { type: String, default: '' }
  },
  computed: {
    canSeeSource() {
      try {
        const token = JSON.parse(localStorage.getItem('token') || '{}');
        const role = token.type || token.userType;
        return ['ADMIN', 'ASSISTANT'].includes(role);
      } catch (e) {
        return false;
      }
    },
    tagType() {
      return this.source === 'XJD' ? 'warning' : 'primary';
    },
    label() {
      const map = { MANUAL: '自建', XJD: '社组' };
      return map[this.source] || this.source;
    },
    iconClass() {
      return this.source === 'XJD' ? 'el-icon-connection' : 'el-icon-edit';
    }
  }
};
</script>

<style scoped>
.source-badge {
  vertical-align: middle;
  margin-left: 4px;
}
.source-badge i {
  margin-right: 2px;
  font-size: 12px;
}
.source-xjd { background: #FDF6EC; color: #E6A23C; border-color: #F5DAB1; }
.source-manual { background: #ECF5FF; color: #409EFF; border-color: #B3D8FF; }
</style>
